import { render, staticRenderFns } from "./rfp-view.vue?vue&type=template&id=6af6eb44&scoped=true&"
import script from "./rfp-view.vue?vue&type=script&lang=js&"
export * from "./rfp-view.vue?vue&type=script&lang=js&"
import style0 from "./rfp-view.vue?vue&type=style&index=0&id=6af6eb44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6eb44",
  null
  
)

export default component.exports